import { z } from 'zod';

export interface KmRefundAccessInput {
  /** `policyAccess` do lookup contém `expenseKm`; `null` = não resolvido. */
  kmPolicy: boolean | null;
  /** `policy.expenseKm.untrackedRoute` ("Solicitação sem rastreamento"); `null` = não resolvido. */
  untrackedRoute: boolean | null;
  /** Bloqueio de gastos confirmado; `null`/ausente = não confirmado (não esconde). */
  spendingBlocked?: boolean | null;
}

export const KmRefundEntrySchema = z.object({ offer: z.boolean() }).strict();
export type KmRefundEntry = z.infer<typeof KmRefundEntrySchema>;

const HIDDEN: KmRefundEntry = { offer: false };

/**
 * Se o reembolso de KM de trajeto já feito aparece: a política `expenseKm` com a "Solicitação sem
 * rastreamento" ligada (é ela que libera o KM manual no legado). Política ou `untrackedRoute` não
 * resolvidos escondem; o bloqueio de gastos só esconde quando CONFIRMADO, como na wallet.
 */
export function kmRefundEntry(input: KmRefundAccessInput): KmRefundEntry {
  const { kmPolicy, untrackedRoute, spendingBlocked } = input;
  if (kmPolicy !== true || untrackedRoute !== true || spendingBlocked === true) return HIDDEN;
  return { offer: true };
}
